import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  as?: React.ElementType; // Allow rendering as a different HTML element, e.g., 'section'
}

const Card: React.FC<CardProps> = ({
  children,
  className,
  as: Component = 'div', // Default to 'div'
  ...props
}) => {
  // Base styles for the card - Dashboard Metrics Chart style
  const cardStyles = `
    bg-surface-light/80 dark:bg-surface-dark/80
    backdrop-blur-sm
    border border-border-light dark:border-border-dark
    rounded-lg
    shadow-sm
    p-6
    transition-all duration-200
    hover:shadow-md
  `;

  const combinedClassName = `
    ${cardStyles}
    ${className || ''}
  `;

  return (
    <Component className={combinedClassName.trim()} {...props}>
      {children}
    </Component>
  );
};

export default Card;
